import { useIntl } from 'react-intl';

import config from '@/config';
import { useSubscriptionUpgradeModal } from '@/modules/saas-upgrade';
import { Icon } from '@/modules/ui';

import { useIsFreeTier } from '../../hooks';
import { SettingsLink } from '../SettingsLink';

// Gating is proactive: no vault endpoint answers "payment required" in this scope, and the free plan's
// vault list simply comes back empty. So a free plan is offered the upgrade rather than an empty page.
export const VaultsSettingsLink = () => {
    const { formatMessage } = useIntl();

    const isFreeTier = useIsFreeTier();
    const { openUpgradeModal } = useSubscriptionUpgradeModal();

    return (
        <SettingsLink
            to={config.routes.vaultsSettings}
            title={formatMessage({ id: 'settings.links.vaults' })}
            trailing={isFreeTier ? <Icon type='premium' color='alertsWarningText' width={20} height={20} /> : undefined}
            onClick={isFreeTier ? openUpgradeModal : undefined}
        />
    );
};
